export default from './post-image';



// WEBPACK FOOTER //
// ./app/components/post-image/index.js